import { Outlet } from "react-router-dom";

/**
 * Minimal layout used by /update-password and other unbranded entry points.
 * Intentionally bare — no header, no sidebar, no branding.
 */
export default function SimpleLayout() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0f172a",
        color: "#f8fafc",
        fontFamily: "Inter, system-ui, sans-serif",
      }}
    >
      <Outlet />
    </div>
  );
}
